// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2dbefc22","460":"8cab80fe"}[chunkId] + ".chunk.js";
};